import ImageLoader from '@/components/features/posts/ImageLoader/ImageLoader';
import PostInfo from '@/components/features/posts/PostInfo/PostInfo';
import { LikeButton } from '@/components/features/posts/SocialBar/LikeButton/LikeButton';
import SocialBar from '@/components/features/posts/SocialBar/SocialBar';
import { withUser } from '@/components/shared/utilities/WithUser/WithUser';
import { useUser } from '@/hooks/useUser';
import { getImageUrl, size } from '@/utils/attachment';
import { POST_ITEMS_TYPES, translatePostItemType } from '@/utils/constants';
import { getCollection } from '@/utils/social-media-share-links';
import { WithTranslation, withTranslation } from 'next-i18next';
import { Component } from 'react';

import ExpandableContent from '../ExpandableContent/ExpandableContent';
import styles from './FeedCollection.module.scss';

interface IFeedCollectionProps extends WithTranslation, ReturnType<typeof useUser> {
	data: any;
}

class FeedCollection extends Component<IFeedCollectionProps> {
	constructor(props: IFeedCollectionProps) {
		super(props);
	}

	render() {
		const { data, user } = this.props;

		const slug = data.slug || data.id;

		return (
			<div className={styles.collectionFeed} key={data.id}>
				<div className={styles.collectionFeedInner}>
					<ImageLoader
						src={getImageUrl(data.image, size.MEDIUM)}
						preloader={getImageUrl(data.image, size.PRELOADER)}
						className={styles.collectionFeedImage}
					/>
					<div className={styles.collectionFeedContent}>
						<div className={styles.collectionFeedTextWrapper}>
							<div className={styles.collectionFeedType}>{translatePostItemType(POST_ITEMS_TYPES[data.type])}</div>
							<h2 className={styles.collectionFeedTitle}>{data.title}</h2>
							<PostInfo className={styles.collectionFeedInfo} data={data} />
							<ExpandableContent className={styles.collectionFeedDescription} content={data.content} />
						</div>
					</div>
					<div className={styles.collectionFeedFooter}>
						{user ? <LikeButton faveable={data} /> : null}

						<SocialBar
							shareLinksCollection={getCollection('/feed/' + slug, data)}
							menuContainerClassName={styles.collectionFeedSocialMenuContainer}
							menuCloseClassName={styles.collectionFeedSocialMenuClose}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(withUser(FeedCollection));
